import { object, optional, boolean } from 'superstruct';

export const rewardsEventsConfigSchema = object({
  disableAchievementsPageLinks: optional(boolean()),
  showCompletedSuffixInToast: optional(boolean()),
});
